import { gql } from "apollo-boost";

export const DEREGISTER_FOR_OPEN_HOUSE = gql`
  mutation deregister_for_open_house($open_house_id: ID!) {
    deregister_for_open_house(input: { open_house_id: $open_house_id }) {
      ... on RegisterOrDeregisterForOpenHouseResult {
        successful
      }
      ... on RegisterOrDeregisterForOpenHouseErrors {
        errors {
          message
          type
        }
      }
    }
  }
`;
